
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface DashboardHeaderProps {
  dashboardView: string;
  setDashboardView: (view: string) => void;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({ dashboardView, setDashboardView }) => {
  return (
    <div className="flex justify-between items-center">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Dashboard</h1>
        <p className="text-muted-foreground">
          Welcome to your financial governance dashboard.
        </p>
      </div>
      <div className="flex items-center gap-4">
        <p className="text-sm text-muted-foreground">View as:</p>
        <Select value={dashboardView} onValueChange={setDashboardView}>
          <SelectTrigger className="w-[180px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="cfo">CFO Dashboard</SelectItem>
            <SelectItem value="compliance">Compliance Officer</SelectItem>
            <SelectItem value="treasury">Treasury Manager</SelectItem>
            <SelectItem value="legal">Legal Manager</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default DashboardHeader;
